export default {
  container: {
    backgroundColor: '#f4f4f4',
    borderRadius: '4px',
    marginBottom: '10px',
    padding: '7.5px',
  },
};
